import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function BookingBanner() {
  return <section className="w-full py-20 px-4 bg-gradient-to-r from-gold via-gold/90 to-gold" data-id="element-1">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center space-y-6" data-id="element-2">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-3">
          ¿Lista para tu próxima cita?
        </h2>

        <p className="text-xl text-white/90" data-id="element-4">Reservá online en segundos</p>

        <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-10 py-4 bg-white text-gold font-bold rounded-full hover:bg-cream transition-colors shadow-xl hover:shadow-2xl mt-8" data-id="element-5">
          Reservar turno
          <ArrowRight className="w-5 h-5" data-id="element-6" />
        </a>
      </motion.div>
    </section>;
}